import React from "react";
import HeaderCommon from "../../components/HeaderCommon/HeaderCommon";
import FooterCommon from "../../components/FooterCommon/FooterCommon";
import Main from "./Components/Main/Main";

export const Withdrawal = ({ currentLang, setCurrentLang }) => {
  return (
    <>
      <HeaderCommon currentLang={currentLang} setCurrentLang={setCurrentLang} />
      <Main />
      <FooterCommon />
    </>
  );
};
